import React from 'react';
import { withWebView } from '../hoc/withWebView';
import AccountDeletionContent from '../components/AccountDeletionContent';

export default withWebView(AccountDeletionContent, 'account-deletion', { showNavigation: false }); 